import { FilterDeclaration } from 'features/filter/types'

import { AVNStageProps } from '../../stages/AVN/types'
import { post } from '../index'

type GetFilterProps = { url: string; filterOptions: AVNStageProps['filterOptions'] }

export const getFilter = ({ url, filterOptions }: GetFilterProps) => post<FilterDeclaration>(url, { filterOptions })
